import { render, staticRenderFns } from "./Translateable.vue?vue&type=template&id=6765111a&scoped=true&"
import script from "./Translateable.vue?vue&type=script&lang=js&"
export * from "./Translateable.vue?vue&type=script&lang=js&"
import style0 from "./Translateable.vue?vue&type=style&index=0&id=6765111a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765111a",
  null
  
)

export default component.exports